import axios from 'axios'
import { useContext, useState } from 'react'
import { useHistory } from 'react-router'
import urlSearchParams from '../../components/urlSearchParams'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { useRestApi } from '../../lib/RestApi/useRestApi'
import { bulkUploadPopup, toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, ROUTES, success } from '../../shared/constants'

export const useStore = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const history = useHistory()
  const [store, setStore] = useState(false)
  const { deleteNewStore, getNewStore, addNewStore, editNewStore } = useContext(ConfigurationContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)
  const { ADD, GET_ALL, UPDATE, GET_SINGLE, DELETE } = useRestApi(setLoading, 'Store', 'STORE', 'GET_ALL_STORE_BY_COMPANY')

  // const getAllStore = async (dto = {}) => {
  //   setLoading(true)
  //   axios
  //     .get(API.GET_ALL_STORE_BY_COMPANY(urlSearchParams(dto)), header)
  //     .then(({ status, data }) => {
  //       //console.log('DATA : ', data)
  //       setLoading(false)
  //       if (status !== 200) {
  //         return toastMessage('Something Went Wrong !', error)
  //       }
  //       setPaginate(data.paginate)
  //       getNewStore(data.data)
  //     })
  //     .catch((err) => {
  //       //console.log(err)
  //       setLoading(false)
  //       if (err.response) {
  //         //console.log(err.response)
  //         return toastMessage(
  //           err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg),
  //           error
  //         )
  //       }
  //     })
  // }
  const getAllStore = async (dto = {}) => {
    GET_ALL('GET_ALL_STORE_BY_COMPANY', setPaginate, getNewStore, dto)
  }
  const addStore = (dto) => {
    setLoading(true)
    axios
      .post(API.ADD_STORE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Store  Added Successfully', success)
        history.push(ROUTES.STORE)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }
  const updateStore = (dto) => {
    setLoading(true)
    axios
      .put(API.EDIT_STORE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Store  Update Successfully', success)
        history.push(ROUTES.STORE)
        getAllStore()
        // { page: 1, limit: 10 }
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getStore = (dto) => {
    setLoading(true)
    axios
      .get(API.GET_STORE(dto.storeId), header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setStore(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteStore = (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_STORE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Store Deleted Successfully', success)

        deleteNewStore(dto.storeId)
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteManyStore = (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_MANY_STORE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(`${dto.storeId.length} Store Deleted Successfully`, success)

        dto.storeId.map((item) => deleteNewStore(item))
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const BulkUpload = async (dto) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        bulkUploadPopup(data, addNewStore)
        getAllStore()
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  return {
    addStore,
    getAllStore,
    deleteStore,
    getStore,
    store,
    updateStore,
    deleteManyStore,
    BulkUpload,
    loading,
    paginate,
  }
}
